import { Component } from 'react';
import Select, { ActionMeta, MultiValue, SingleValue } from 'react-select';

import { OnChangeType } from 'types/functions';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface Option {
    value: boolean | string | number | undefined; // Allow undefined as a valid value
    label: string;
}

interface DropListProps {
    className?: string;
    isMulti?: boolean;
    name: string;
    id?: string;
    placeholder?: string;
    options: Option[];
    value: boolean | string | number | (string | number)[];
    onChange: OnChangeType;
    disabled?: boolean;
    capitalize?: boolean;
    translate?: boolean;
}

interface DropListState {
    selectedValue: boolean | string | number | (string | number)[];
}

class DropList extends Component<DropListProps, DropListState> {
    constructor(props: DropListProps) {
        super(props);
        this.state = {
            selectedValue: props.value,
        };
    }

    static getDerivedStateFromProps(nextProps: DropListProps, prevState: DropListState) {
        if (checkDifferent(nextProps.value, prevState.selectedValue)) {
            return {
                selectedValue: nextProps.value,
            };
        }
        return null;
    }

    handleChange = (e: MultiValue<Option> | SingleValue<Option> | null, actionMeta: ActionMeta<Option>) => {
        const { isMulti, name, options, onChange } = this.props;

        if (isMulti) {
            if (!e) {
                onChange(name, []);
            } else if (Array.isArray(e) && e.some((x) => x.value === '*')) {
                onChange(
                    name,
                    options.filter((x) => x.value !== '*').map((x) => x.value)
                );
            } else if (Array.isArray(e)) {
                onChange(
                    name,
                    e.map((x) => x.value)
                );
            }
        } else {
            onChange(name, (e as Option)?.value ?? '');
        }
    };

    // capitalizeFirstWord = (str) => {
    //     const [first, ...rest] = str.split(' ');
    //     return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
    // };

    render() {
        const { className = 'w-full', isMulti, name, id, placeholder, options, disabled, capitalize } = this.props;
        const { selectedValue } = this.state;
        const updatedOptions = options.map((x) => {
            return { ...x, label: this.props.translate === false ? x.label : translate(x.label) };
        });
        return (
            <Select
                className={className}
                styles={{
                    menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 101,
                    }),
                    //@ts-ignore
                    option: (provided) => ({
                        ...provided,
                        textTransform: capitalize && 'capitalize',
                    }),
                }}
                isMulti={isMulti}
                name={name}
                id={id}
                closeMenuOnSelect={!isMulti}
                isSearchable
                value={
                    isMulti
                        ? updatedOptions.filter(
                              //@ts-ignore
                              (x) => Array.isArray(selectedValue) && selectedValue.includes(x.value || '')
                          )
                        : updatedOptions.find((x) => x.value === selectedValue) || null
                }
                placeholder={placeholder}
                menuPortalTarget={document.body}
                options={updatedOptions}
                isDisabled={disabled}
                onChange={this.handleChange}
            />
        );
    }
}

export default DropList;
